import {
  Stack,
  Backdrop,
  Card,
  CardContent,
  Typography,
  Button
} from '@mui/material'

const RefreshPopup = () => {
  const onRefreshClick = () => {
    window.location.reload()
  }
  return (
    <Backdrop open sx={{zIndex: theme => theme.zIndex.snackbar + 1}}>
      <Card>
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Stack spacing={2}>
            <Stack alignItems="right">
              <Typography
                variant="h5"
                sx={{
                  fontFamily: 'Heebo',
                  fontWeight: 'bold'
                }}
              >
                שגיאה
              </Typography>
            </Stack>
            <Stack alignItems="center">
              <Typography variant="h6">
                ארעה שגיאה בטעינת העמוד. אנא לחץ על "ריענון" כדי לנסות שוב.
              </Typography>
            </Stack>
            <Button
              style={{
                fontSize: 'large',
                width: '100px',
                alignSelf: 'end',
                padding: '8px',
                backgroundColor: '#4d0026',
                color: 'white',
                fontWeight: 'bold',
                borderRadius: '15px'
              }}
              onClick={onRefreshClick}
            >
              רענון
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Backdrop>
  )
}
export default RefreshPopup
